import { render, staticRenderFns } from "./AlertsState.vue?vue&type=template&id=04920905&scoped=true&"
import script from "./AlertsState.vue?vue&type=script&lang=js&"
export * from "./AlertsState.vue?vue&type=script&lang=js&"
import style0 from "./AlertsState.vue?vue&type=style&index=0&id=04920905&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04920905",
  null
  
)

export default component.exports